module.exports = __webpack_public_path__ + "static/logo-2c9347a4ccd4642216af2c203c2924b7.svg";